/* Confluence race-results navigation instrumentation.
   These events are available to connected Shopify Pixels and GTM dataLayer listeners.
   A GA4 event tag must subscribe to them before GA4 reports them. */
(function(){
  'use strict';
  if(window.__confluenceRaceResultsTracker)return;
  window.__confluenceRaceResultsTracker=true;
  document.addEventListener('click',function(evt){
    var target=evt.target;
    var link=target && target.closest ? target.closest('a[href]') : null;
    if(!link)return;
    var url;
    try{url=new URL(link.getAttribute('href'),window.location.href);}catch(e){return;}
    var path=url.pathname||'';
    var sameSite=url.hostname===window.location.hostname;
    var inResultsArea=!!link.closest('#results-history,.race-results-history,.results-archive');
    var isJump=(url.hash==='#results-history' && (window.location.pathname.indexOf('/pages/races/')===0 || window.location.pathname.indexOf('/pages/race-calendar')===0));
    var isArchive=path.indexOf('/pages/race-results/')===0;
    var isExplicit=link.hasAttribute('data-race-results-link');
    var isReport=inResultsArea && (/\.pdf($|\?)/i.test(url.pathname+url.search) || link.closest('.race-history-reports') || link.classList.contains('race-history-coverage-link'));
    if(!isJump&&!isArchive&&!isExplicit&&!isReport)return;
    var context=link.closest('.race-card,.race-year,.race-detail,.race-history-card,.race-results-history__card,.results-archive');
    var raceNameNode=(context&&context.querySelector('.race-card__title,.race-detail__title,.race-history-card__title,.race-year__heading h2,.results-archive__header h1'))||document.querySelector('h1');
    var raceName=raceNameNode ? (raceNameNode.textContent||'').trim().slice(0,160) : '';
    var yearText=link.getAttribute('data-race-year') || (link.textContent||'') || path;
    var yearMatch=yearText.match(/\b20\d{2}\b/) || path.match(/\b20\d{2}\b/);
    var year=yearMatch?yearMatch[0]:'';
    var kind=isJump?'section_jump':isReport?'report':isArchive?'archive':'coverage';
    var action=isJump?'race_results_jump':'race_results_click';
    var info={race_name:raceName,race_year:year,result_type:link.getAttribute('data-race-result-type')||kind,link_surface:link.getAttribute('data-race-surface')||(inResultsArea?'results-history':'inline'),link_location:window.location.pathname,destination_path:url.pathname,destination_type:kind,link_text:(link.textContent||'').trim().slice(0,100)};
    try{window.dataLayer=window.dataLayer||[];window.dataLayer.push(Object.assign({event:action},info));}catch(e){}
    try{if(window.Shopify&&window.Shopify.analytics&&typeof window.Shopify.analytics.publish==='function'){window.Shopify.analytics.publish(action,info);}}catch(e){}
  },false);

  // Track when the actual results panel enters a visitor's viewport.
  var panel=document.querySelector('[data-race-result-panel]');
  if(panel&&'IntersectionObserver' in window){
    var observer=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(!entry.isIntersecting)return;
        var detail={race_name:panel.getAttribute('data-race-name')||'',race_year:panel.getAttribute('data-race-year')||'',link_location:window.location.pathname,result_type:'results_panel',link_surface:'primary-panel'};
        try{window.dataLayer=window.dataLayer||[];window.dataLayer.push(Object.assign({event:'race_results_view'},detail));}catch(e){}
        try{if(window.Shopify&&window.Shopify.analytics&&typeof window.Shopify.analytics.publish==='function'){window.Shopify.analytics.publish('race_results_view',detail);}}catch(e){}
        observer.disconnect();
      });
    },{threshold:.35});
    observer.observe(panel);
  }
})();